import createReducer from './_createReducerHelper';

export const NETWORK_CONNECTED = 'network/IS_NETWORK_CONNECTED';

const initialState = {
  networkConnected: null,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [NETWORK_CONNECTED]: (state, { payload }) => ({ ...state, networkConnected: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param isConnected
 * @return {{type, payload: *}}
 */
export const setNetworkConnected = (isConnected) => ({
  type: NETWORK_CONNECTED,
  payload: isConnected,
});

/** ********************************************
 * selectors
 ******************************************** */

export const selectNetworkConnected = (state) => state.network.networkConnected;
